
/* FAQ structured data, built from the FAQ already on the page rather than a
   second hand-maintained copy — the two can never drift apart. At migration
   this is better emitted straight from the section's blocks in Liquid. */
(function(){
  var qs = [].slice.call(document.querySelectorAll('#faq details'));
  if (!qs.length) return;
  var s = document.createElement('script');
  s.type = 'application/ld+json';
  s.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": qs.map(function(d){
      return { "@type": "Question",
        "name": (d.querySelector('summary').textContent || '').trim(),
        "acceptedAnswer": { "@type": "Answer",
          "text": (d.querySelector('p').textContent || '').trim() } };
    })
  });
  document.head.appendChild(s);
})();
